import { inject, makeEnvironmentProviders } from '@angular/core';
import { FEATURE_FLAG, FeatureFlagService } from '@quipex/core/config';
import {
    APP_TOP_BAR_ELIGIBILITY,
    provideAppTopBarScopeRegistry,
} from '@quipex/core/layout';

export function provideAppTopBarRollout() {
    return makeEnvironmentProviders([
        provideAppTopBarScopeRegistry(),
        {
            provide: APP_TOP_BAR_ELIGIBILITY,
            useFactory: () => {
                const featureFlagService = inject(FeatureFlagService);

                return featureFlagService.flagEnabled(FEATURE_FLAG.AppTopBar);
            },
        },
    ]);
}
